exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* smartphones, iPhone, portrait 480x320 phones */\n/* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */\n/* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */\n/* tablet, landscape iPad, lo-res laptops ands desktops */\n/* big landscape tablets, laptops, and desktops */\n/* hi-res laptops and desktops */\ntable {\n  padding: 5px;\n  width: 100%;\n  border-spacing: 0;\n  font-size: 2vw;\n  color: white;\n  transition: 0.25s ease; }\n\ntd {\n  width: 33.33%;\n  position: relative; }\n\ntd:after {\n  content: '';\n  display: block;\n  margin-top: 49%; }\n\ntd .content {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  text-align: center;\n  padding: 5px; }\n\n.disabled {\n  opacity: 0.5;\n  pointer-events: none; }\n\n.way-to-finish {\n  display: block;\n  position: fixed;\n  top: 6vh;\n  left: 50vw;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  font-size: 2rem;\n  padding: 10px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/game-pad/game-pad.component.scss
// module id = ./src/app/components/game-pad/game-pad.component.scss
// module chunks = main